import { Navigate, Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useVendorStatus } from '@/hooks/useVendorStatus';

/**
 * Layout gate for routes that only make sense once a store is verified
 * (dashboard, catalog, orders, finance, analytics, reviews). Used as a parent
 * route element so every nested route is gated by default — no per-route
 * wrapper to forget. Unverified vendors are sent to the Pending screen instead
 * of a broken, empty dashboard. KYC-fixing routes (/store, /settings, /pending)
 * live outside this group and stay open.
 */
export function RequireApproved() {
  const { status, isLoading } = useVendorStatus();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-32 text-slate-500">
        <Loader2 className="h-6 w-6 animate-spin mr-2" /> Loading your store…
      </div>
    );
  }

  if (status !== 'approved') {
    return <Navigate to="/pending" replace />;
  }

  return <Outlet />;
}
